<div class="mt-3" [class.hideRow]="hideRow" *ngIf="product">
    <form [formGroup]="form" [id]="product.identifier ? product.identifier : 'new-budget-product'"
        [ngClass]="editForm ? 'editForm' : ''" style="border-radius: 5px;">
        <div class="row mb-3 align-items-flex-end">
            <div class="form-group col-lg-5">
                <label>{{'order.product.product' | translate}}</label>
                <apc-form-select formControlName="product" [items]="products" (isOpen)="fetchProducts()"
                    [loading]="productsLoading" [isObject]="true" (isChanged)="patchCode($event, form)"
                    [optionDescription]="['code']" [autogenerated]="form.value.product && form.value.identifier">
                </apc-form-select>
            </div>
            <div class="form-group col-lg-5">
                <label>{{'order.product.code' | translate}}</label>
                <apc-form-input [class]="'form-control autogenerated'" [wrapperClass]="'height-auto'" [disabled]="true" formControlName="code"
                    [type]="'text'">
                </apc-form-input>
            </div>
            <div class="form-group col-lg-2 " *checkPermission="{ role: 'editor'}">
                <div class="row justify-content-center">
                    <div ngbTooltip="{{'buttons.edit' | translate}}" tooltipClass="animation-tooltip" placement="top"
                        container="body" triggers="hover" *ngIf="!editForm">
                        <button class="extra-button yellow" (click)="editFormEvent($event)">
                            <img src="assets/ico/edit.svg" alt="edit" />
                        </button>
                    </div>
                    <div ngbTooltip="{{'buttons.save' | translate}}" tooltipClass="animation-tooltip" placement="top"
                        container="body" triggers="hover" *ngIf="editForm">
                        <button class="extra-button green" id="save-button" (click)="saveForm()">
                            <img class="save" src="assets/ico/save.svg" alt="save" />
                        </button>
                    </div>
                    <div ngbTooltip="{{'buttons.undo' | translate}}" tooltipClass="animation-tooltip" placement="top"
                        container="body" triggers="hover" *ngIf="editForm">
                        <button class="extra-button red" (click)="cancelForm()">
                            <img class="undo" src="assets/ico/undo-24px.svg" alt="back" />
                        </button>
                    </div>
                    <div ngbTooltip="{{'buttons.delete' | translate}}" tooltipClass="animation-tooltip" triggers="hover"
                        *ngIf="!editForm">
                        <app-modal-info title="Confirm action" text="Are you sure to delete this item?" color="red"
                            isQuestion="false" iconSrc="assets/ico/trash-alt-regular.svg" (confirmEvent)="delete()">
                            <span action>
                                <button class="extra-button red">
                                    <img src="assets/ico/trash-alt-regular.svg" alt="edit" />
                                </button>
                            </span>
                        </app-modal-info>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mb-3">
            <div class="form-group col-lg-5">
                <label>{{'order.product.quantityOrder' | translate}} *</label>
                <apc-form-input [class]="'form-control'" formControlName="quantityOrder" [type]="'number'"  [limitBeforeComma]="15">
                </apc-form-input>
            </div>
            <div class="form-group col-lg-5">
                <label>{{'order.product.quantityEstimated' | translate}}<span class="tooltip-info" ngbTooltip="{{'order.budget.estimatedHoursInfo' | translate}}" tooltipClass="animation-tooltip" placement="top" container="body"  triggers="hover">&#63;</span></label>
                <apc-form-input [class]="'form-control'" [limitBeforeComma]="15" formControlName="quantityEstimated" [placeholder]="'order.budget.estimatedHoursPlaceholder' | translate" [type]="'number'" >
                </apc-form-input>
            </div>
        </div>
    </form>
</div>